import { render, staticRenderFns } from "./tzgg.vue?vue&type=template&id=034b0224&scoped=true"
import script from "./tzgg.vue?vue&type=script&lang=js"
export * from "./tzgg.vue?vue&type=script&lang=js"
import style0 from "./tzgg.vue?vue&type=style&index=0&id=034b0224&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034b0224",
  null
  
)

export default component.exports